import React from 'react';

import FormTemplatesListView from './FormTemplatesListView';
import FormTemplatesTreeView from './FormTemplatesTreeView';
import { useFormsFolders } from '../hooks';

const FormTemplatesCustomDataView = ({ filters = {}, ...rest }) => {
  const { data: folders, isLoading: isLoadingFolders } = useFormsFolders();

  return filters.searchExpression ? (
    <FormTemplatesListView
      filters={filters}
      isLoadingFolders={isLoadingFolders}
      folders={folders}
      {...rest}
    />
  ) : (
    <FormTemplatesTreeView
      filters={filters}
      isLoadingFolders={isLoadingFolders}
      folders={folders}
      {...rest}
    />
  );
};

FormTemplatesCustomDataView.displayName = 'FormTemplatesCustomDataView';

export default FormTemplatesCustomDataView;
